// File: frontend/src/components/Admin/FlaggedNotesManagement.jsx

import React, { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import { logsAPI } from '../../services/api';

export default function FlaggedNotesManagement() {
  const [pending, setPending] = useState([]);
  const [reviewingId, setReviewingId] = useState(null);

  const fetchPending = useCallback(() => {
    logsAPI.getPending().then(setPending).catch(() => {});
  }, []);

  useEffect(() => {
    fetchPending();
  }, [fetchPending]);

  const handleReview = async (id, action) => {
    setReviewingId(id);
    try {
      await logsAPI.review(id, action);
      setPending(prev => prev.filter(n => n.id !== id));
      toast.success(action === 'approve' ? 'Note approved and sent.' : 'Note rejected.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not review note.');
    } finally {
      setReviewingId(null);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
      <h3 className="font-semibold mb-2 flex items-center gap-1.5">
        🚩 Flagged Notes
        {pending.length > 0 && (
          <span className="bg-amber-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold">{pending.length}</span>
        )}
      </h3>
      <div className="border rounded p-2 max-h-48 overflow-y-auto space-y-2">
        {pending.length === 0 ? (
          <p className="text-xs text-gray-400 dark:text-gray-500 italic py-3 text-center">No notes awaiting review.</p>
        ) : (
          pending.map(note => (
            <div key={note.id} className="p-2 bg-amber-50 border border-amber-200 rounded text-xs space-y-1">
              <div className="font-semibold text-gray-800 dark:text-gray-200">
                {note.student_name} <span className="text-gray-400 dark:text-gray-500 font-normal">by {note.user_name}</span>
              </div>
              <div className="text-gray-700 dark:text-gray-300 italic">"{note.note}"</div>
              <div className="text-amber-700 font-medium">{note.flagged_reason}</div>
              <div className="flex gap-1.5 pt-1">
                <button
                  type="button"
                  disabled={reviewingId === note.id}
                  onClick={() => handleReview(note.id, 'approve')}
                  className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-2 py-1 rounded"
                >
                  ✓ Approve & Send
                </button>
                <button
                  type="button"
                  disabled={reviewingId === note.id}
                  onClick={() => handleReview(note.id, 'reject')}
                  className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold px-2 py-1 rounded"
                >
                  ✕ Reject
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
